import React, { useState, useEffect } from "react";
import axios from "axios";
import { validateLomPresidentAddData } from "../../Validate"; // Import the validation function
import Dropdown from "../../DropDown";
import InputField from "../../InputField";
import Swal from "sweetalert2";

const AddLomPresidentModal = ({ show, onClose, onSubmit }) => {
  
  const [districtOptions, setDistrictOptions] = useState([]);
  const [formData, setFormData] = useState({
    lomName: "",
    startYear: "",
    endYear: "",
    name: "",
    membershipId: "",
    address: "",
    contactNumber: "",
    whatsapp_no:"",
    facebook: "",
    instagram: "",
    youtube: "",
    linkedIn: "",
    isTrainer: false,
    trainerZoneXVIII: "",
    highest_portfolio: "",
    highest_position_training: "",
    dob: "",
    district: "",
    year: "",
  });

  const [loms, setLoms] = useState([]);
  const [errors, setErrors] = useState({}); // State to store validation errors

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  useEffect(() => {
    axios
      .get("/lom/read")
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];
        setLoms(data);
      })
      .catch((error) => console.error("Error fetching LOMs:", error));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateLomPresidentAddData(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      axios
        .post("/lom_president/add_lom_president", formData) // Replace with your backend API endpoint
        .then((response) => {
            // Display SweetAlert success message
            Swal.fire({
              title: 'Success!',
              text: 'LOM President added successfully.',
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then(() => {
              // Reload the page after the alert is closed
              window.location.reload(); // Reload the page

              // Close the modal and reset form data
              onClose();
              resetFormData();
            });
        })
        .catch((error) => {
          console.error("Error submitting data:", error);
        });
    }
  };

  const handleDropdownChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      district: field === "trainerZoneXVIII" ? "" : prev.district,
    }));
  };

  
  const resetFormData = () => {
    setFormData({
      lomName: "",
      startYear: "",
      endYear: "",
      name: "",
      membershipId: "",
      address: "",
      contactNumber: "",
      whatsapp_no:"",
      facebook: "",
      instagram: "",
      youtube: "",
      linkedIn: "",
      isTrainer: false,
      trainerZoneXVIII: "",
      highest_portfolio: "",
      highest_position_training: "",
      dob: "",
      district: "",
      year: "",
    });
    setErrors({}); // Clear any validation errors
  };

  // Handle "Cancel" button click
  const handleCancel = () => {
    resetFormData();  // Reset the form data
    onClose();  // Close the modal
  };

  // Generate an array of years from current year to 1900
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => currentYear - index
  );


  const fetchDistrictOptions = async () => {
    try {
      const zoneValue = formData.trainerZoneXVIII;
      const response = await axios.get(`/zone_district/read_zone_18?zone_18=${zoneValue}`);
      const districts = response.data.map((district) => district.district_name);
      setDistrictOptions(districts);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistrictOptions([]);
    }
  };

  useEffect(() => {
    if (formData.trainerZoneXVIII) {
      fetchDistrictOptions();
    }
  }, [formData.trainerZoneXVIII]);


  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-6 max-w-2xl w-full rounded shadow-lg overflow-y-auto max-h-[80vh]">
        <h2 className="text-lg font-bold mb-4">Add LO</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* LOM Name */}
            <div>
              <label className="block text-sm font-medium mb-1">LO<span className="text-red-600"> *</span></label>
              <select
                id="lomDropdown"
                className="border rounded p-2 w-full"
                value={formData.lomId}
                onChange={(event) =>
                  setFormData({ ...formData, lomId: event.target.value })
                }
                required
              >
                <option value="">-- Select an Option --</option>
                {loms.map((lom) => (
                  <option key={lom.lom_id} value={lom.lom_id}>
                    {lom.lom_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Name */}
            <div>
              <label className="block text-sm font-medium mb-1">Name with Title<span className="text-red-600"> *</span></label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                placeholder="Dr. S. Jashan"
              />
              {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            </div>

            {/* Member ID */}
            <div>
              <label className="block text-sm font-medium mb-1">Member ID <span className="text-red-600"> *</span></label>
              <input
                type="text"
                name="membershipId"
                value={formData.membershipId}
                onChange={handleChange}
                placeholder="37"
                className="w-full border rounded px-3 py-2"
              />
              {errors.membershipId && <p className="text-red-500 text-sm">{errors.membershipId}</p>}
            </div>

            {/* Contact Number */}
            <div>
              <label className="block text-sm font-medium mb-1">Contact Number <span className="text-red-600"> *</span></label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                placeholder="9087562345"
                className="w-full border rounded px-3 py-2"
              />
              {errors.contactNumber && <p className="text-red-500 text-sm">{errors.contactNumber}</p>}
            </div>

            <div>
                  <label className="block text-sm font-medium text-gray-700">
                  Whatsapp Number <span className="text-red-600"> *</span>
                  </label>
                  <input
                    type="text"
                    name="whatsapp_no"
                    value={formData.whatsapp_no}
                    onChange={handleChange}
                    placeholder="9087562345"
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  />
                  {errors.whatsapp_no && <p className="text-red-500 text-sm">{errors.whatsapp_no}</p>}
           </div>

            {/* Period of Presidency */}
            <div className="col-span-2">
              <h3 className="text-sm font-bold mb-4 text-blue-600">Period of Presidency</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Start Year */}
                <div>
                  <label className="block text-sm font-medium mb-1">Start Year<span className="text-red-600"> *</span></label>
                  <select
                    name="startYear"
                    value={formData.startYear}
                    onChange={handleChange}
                    required
                    className="w-full border rounded px-3 py-2"
                  >
                    <option value="">Select Start Year</option>
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  {errors.startYear && <p className="text-red-500 text-sm">{errors.startYear}</p>}
                </div>

                {/* End Year */}
                <div>
                  <label className="block text-sm font-medium mb-1">End Year <span className="text-red-600"> *</span></label>
                  <select
                    name="endYear"
                    value={formData.endYear}
                    onChange={handleChange}
                    required
                    className="w-full border rounded px-3 py-2"
                  >
                    <option value="">Select End Year</option>
                    {yearOptions
                      .filter((year) => year >= formData.startYear) // Filter end years that are greater than or equal to start year
                      .map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                  </select>
                  {errors.endYear && <p className="text-red-500 text-sm">{errors.endYear}</p>}
                </div>
              </div>
            </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Address <span className="text-red-600"> *</span>
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="virudhunagar"
                className="w-full border rounded px-3 py-2"
              />
              {errors.address && <p className="text-red-500 text-sm">{errors.address}</p>}
            </div>

            {/* Social Media URLs */}
            <div>
              <label className="block text-sm font-medium mb-1">Facebook</label>
              <input
                type="url"
                name="facebook"
                value={formData.facebook}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.facebook && <p className="text-red-500 text-sm">{errors.facebook}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Instagram</label>
              <input
                type="url"
                name="instagram"
                value={formData.instagram}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.instagram && <p className="text-red-500 text-sm">{errors.instagram}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">YouTube</label>
              <input
                type="url"
                name="youtube"
                value={formData.youtube}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.youtube && <p className="text-red-500 text-sm">{errors.youtube}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">LinkedIn</label>
              <input
                type="url"
                name="linkedIn"
                value={formData.linkedIn}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.linkedIn && <p className="text-red-500 text-sm">{errors.linkedIn}</p>}
            </div>

            {/* Trainer */}
            <div className="flex items-center">
              <input
                type="checkbox"
                name="isTrainer"
                checked={formData.isTrainer}
                onChange={handleChange}
                className="mr-2"
              />
              <label className="text-sm font-medium">Whether he/she is a Trainer</label>
            </div>
            {/* Show fields only if "isTrainer" is true */}
            {formData.isTrainer && (

              <div>
                {/* Dropdown for Trainer Zone XVIII */}
                <Dropdown
                  label="Trainer from Zone XVIII (18)"
                  name="trainerZoneXVIII"
                  value={formData.trainerZoneXVIII || ""}
                  options={[{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }]}
                  className="mb-4"
                  onChange={(event) =>
                    handleDropdownChange("trainerZoneXVIII", event.target.value)
                  }
                  required
                />

                {/* Conditional display for district based on trainerZoneXVIII */}
                {formData.trainerZoneXVIII === "Yes" && (
                  <div className="mb-4">
                    <label className="block mb-2">
                      District<span className="text-red-600"> *</span>
                    </label>
                    <select
                      name="district"
                      value={formData.district}
                      onChange={(event) =>
                        handleChange({ target: { name: "district", value: event.target.value } })
                      }
                      required
                      className="border rounded p-2 w-full"
                    >
                      <option value="" disabled>
                        Select a district
                      </option>
                      {districtOptions.map((district) => (
                        <option key={district} value={district}>
                          {district}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {formData.trainerZoneXVIII === "No" && (
                  <div className="mb-4">
                    <label className="block mb-2">
                      District<span className="text-red-600"> *</span>
                    </label>
                    <input
                      list="district-options"
                      name="district"
                      value={formData.district}
                      onChange={handleChange}
                      required
                      className="border rounded p-2 w-full mb-4"
                      placeholder="Select or type a district"
                    />
                    <datalist id="district-options">
                      {districtOptions.map((district) => (
                        <option key={district} value={district}>
                          {district}
                        </option>
                      ))}
                    </datalist>
                  </div>
                )}

                {/* Additional Trainer Details */}
                 <div>
                  <label className="block text-sm font-medium text-gray-700">
                  Highest Portfolio in JCI <span className="text-red-600"> *</span>
                  </label>
                  <input
                    type="text"
                    name="highest_portfolio"
                    value={formData.highest_portfolio}
                    onChange={handleChange}
                    placeholder="Portfolio"
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  />
                  {errors.highest_portfolio && <p className="text-red-500 text-sm">{errors.highest_portfolio}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Portfolio Year <span className="text-red-600"> *</span></label>
                  <select
                    name="year"
                    value={formData.year}
                    onChange={handleChange}
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  >
                    <option value="">Select Year</option>
                    {yearOptions
                      .filter((year) => year >= formData.startYear) // Filter end years that are greater than or equal to start year
                      .map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                  </select>
                  {errors.year && <p className="text-red-500 text-sm">{errors.year}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                  Highest Position in Training <span className="text-red-600"> *</span>
                  </label>
                  <input
                    type="text"
                    name="highest_position_training"
                    value={formData.highest_position_training}
                    onChange={handleChange}
                    placeholder="Position"
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  />
                  {errors.highest_position_training && <p className="text-red-500 text-sm">{errors.highest_position_training}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                  Date of Birth <span className="text-red-600"> *</span>
                  </label>
                  <input
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    placeholder="dob"
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  />
                  {errors.dob && <p className="text-red-500 text-sm">{errors.dob}</p>}
                </div>
                {/* <div>
                  <label className="block text-sm font-medium text-gray-700">
                  Whatsapp Number <span className="text-red-600"> *</span>
                  </label>
                  <input
                    type="text"
                    name="whatsapp_no"
                    value={formData.whatsapp_no}
                    onChange={handleChange}
                    placeholder="9087562345"
                    required
                    className="w-full border rounded px-3 py-2 mb-4"
                  />
                  {errors.whatsapp_no && <p className="text-red-500 text-sm">{errors.whatsapp_no}</p>}
                </div> */}
              </div>
           
            )}
          </div>
          <div className="flex justify-end mt-4">
             <button
              type="button"
              onClick={handleCancel}  // Reset form and close modal
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Cancel
            </button>
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>

  );
};

export default AddLomPresidentModal;



